import React, { useEffect, useState, useCallback } from 'react';
import { Select } from 'antd';
import { Container, StoryBodyBox } from './styles';
import Loading from '../../components/loading';
import { useAuth } from '../../context/authContext';
import UsergroupBar from '../../components/UsergroupBar';
import { getStoryWidgets } from '../../utils/fixedWidgets';
import { Widget } from '../UserGroupsPage';
import { StoryUnit } from '../../components/addImagesStory';
import Story from '../../components/story';

const StoryPage: React.FC = () => {
  const { user } = useAuth();

  const [stories, setStories] = useState<StoryUnit[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedWidget, setSelectedWidget] = useState<Widget>();
  const [allStoryWidgets, setAllStoryWidgets] = useState<Widget[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const selectedId = Number(urlParams.get('id')) ?? undefined;
    const storyWidgets = getStoryWidgets(
      user?.selectedUsergroup?.settings?.widgets.children,
    );

    setAllStoryWidgets(storyWidgets);

    if (selectedId) {
      const selectedStoryWidget = storyWidgets.find(
        widget => widget.widgetId === selectedId,
      );

      if (selectedStoryWidget) {
        setSelectedWidget(selectedStoryWidget);

        setStories(
          selectedStoryWidget?.stories?.map((story: StoryUnit) => ({
            type: story.type,
            url: story.url,
            duration: story.duration,
          })) ?? [],
        );
      }
    }
    setIsLoading(false);
  }, [user.selectedUsergroup]);

  const handleChangeStory = (widgetId: number): void => {
    const widgetObj: Widget | null =
      allStoryWidgets.find(widget => widget.widgetId === widgetId) ?? null;

    if (widgetObj !== null) {
      setSelectedWidget(widgetObj);
      setStories(widgetObj?.stories ?? []);
    } else {
      console.error(`Widget ${widgetId} was not found`);
    }
  };

  const onChangeUsergroup = useCallback(() => {}, []);

  return (
    <>
      <UsergroupBar
        barContent={
          isLoading ? (
            <div></div>
          ) : (
            <Select
              style={{ width: '25%', height: '100%' }}
              value={selectedWidget?.widgetId}
              placeholder="Select a story"
              onChange={handleChangeStory}
              optionLabelProp="label"
              options={allStoryWidgets.map((widget: Widget) => ({
                value: widget.widgetId,
                label: <span>{widget.name}</span>,
              }))}
            />
          )
        }
        onChangeUsergroup={onChangeUsergroup}
      >
        {isLoading ? (
          <Container>
            <Loading />
          </Container>
        ) : (
          <Container>
            <StoryBodyBox>
              <Story
                key={selectedWidget?.widgetId}
                stories={stories ?? []}
              ></Story>
            </StoryBodyBox>
          </Container>
        )}
      </UsergroupBar>
    </>
  );
};

export default StoryPage;
